export default {
    GetAdList(state) {
        return state.adList;
    },
    GetPlacementList(state) {
        return state.PlacementList;
    },
    GetAdObject(state) {
        return state.currentAdObject;
    },
    GetAdDetails(state) {
        return state.currentAdDetails;
    },
    GetEntities(state) {
        return state.entitiesList;
    },
}